import { render, staticRenderFns } from "./EULA.vue?vue&type=template&id=2b8b6d5e&"
import script from "./EULA.vue?vue&type=script&lang=js&"
export * from "./EULA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports